import { Placement, Step } from "react-joyride";
import React from "react";
import { WarehouseTutorialType } from "../../../utils/enums";
import { getProductMovementConfigArray } from "./stepConfigurations/productMovementConfigArray";
import { getConsumablesWriteOffConfigArray } from "./stepConfigurations/consumablesWriteOffConfigArray";
import { getProductSalesConfigArray } from "./stepConfigurations/productSalesConfigArray";

export interface HeadroomRule {
    minW?: number;
    maxW?: number;
    top?: number;
    bottom?: number;
}

export interface CustomStep extends Step {
    target: string;
    content: React.ReactNode;
    disableBeacon?: boolean;
    showSkipButton?: boolean;
    hideCloseButton?: boolean;
    placement?: Placement;
    spotlightClicks?: boolean;
    disableOverlay?: boolean;
    disableOverlayClose?: boolean;
    observeResize?: boolean;
    goNext?: () => void;
    scrollOffset?: number;
    pageScrollReposition?: boolean;
    headroomRules?: HeadroomRule[];
    headroomTarget?: string;
    topHeadroom?: number;
    bottomHeadroom?: number;
    styles?: {
        options?: {
            zIndex?: number;
            overlayColor?: string;
        };
    };
    route?: string;
}

interface GetWarehouseJoyrideStepsArgs {
    branchId: string;
    currentCompanyId: string;
    tutorialType: WarehouseTutorialType;
    hasSelectedServices?: boolean;
    hasProducts?: boolean;
    goNext?: () => void;
}

export const getWarehouseJoyrideSteps = ({
    branchId,
    currentCompanyId,
    tutorialType,
    hasSelectedServices,
    hasProducts,
    goNext,
}: GetWarehouseJoyrideStepsArgs): CustomStep[] => {
    switch (tutorialType) {
        case WarehouseTutorialType.WAREHOUSE_PRODUCT_MOVEMENT:
            return getProductMovementConfigArray(branchId, hasProducts, goNext);
        case WarehouseTutorialType.CONSUMABLES_WRITE_OFF:
            return getConsumablesWriteOffConfigArray(
                branchId,
                currentCompanyId,
                hasSelectedServices,
                hasProducts,
                goNext
            );
        case WarehouseTutorialType.PRODUCT_SALES:
            return getProductSalesConfigArray(branchId, hasProducts, goNext);
        default:
            return [];
    }
};
